// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"609":"518b86e9","912":"3f8fce13"}[chunkId] + ".chunk.css";
};